import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingSecurities: false,
  loadingSecurityDetail: false,
  perpBondList: [],
  perpBondSelected: null,
  error: null,
  requireProductTestModalVisible: false,
};

const slice = createSlice({
  initialState,
  name: "perpetualBond",
  reducers: {
    fetchPerpBondList: (state) => {
      state.loadingSecurities = true;
      state.perpBondList = [];
    },
    fetchPerpBondListSuccess: (state, action) => {
      state.loadingSecurities = false;
      state.perpBondList = action.payload || [];
    },
    fetchPerpBondListFailure: (state, action) => {
      state.loadingSecurities = false;
      state.error = action.error;
    },
    selectPerpBond: (state, action) => {
      state.loadingSecurityDetail = true;
      state.perpBondSelected = null;
    },
    selectPerpBondSuccess: (state, action) => {
      state.loadingSecurityDetail = false;
      state.perpBondSelected = action.payload;
    },
    selectPerpBondFailure: (state, action) => {
      state.loadingSecurityDetail = false;
      state.error = action.error;
    },
    clearError: (state) => {
      state.error = null;
    },
    saveVdoTime: (state, action) => {
      state.perpBondSelected.video.lastWatchedTime = action.payload;
    },
    acceptedVideo: (state) => {
      state.perpBondSelected.video.lastWatchedTime = null;
      state.perpBondSelected.video.status = true;
    },
    acceptedKnowledgeAssessment: (state) => {
      state.perpBondSelected.ka.status = true;
    },
    acceptedSecuritiesKnowledge: (state) => {
      state.perpBondSelected.productTest.status = true;
    },
    acceptedRiskAwareSignature: (state) => {
      state.perpBondSelected.risk.status = true;
    },
    acceptedPreCaution: (state) => {
      state.perpBondSelected.precaution.status = true;
    },
    setRequireProductTestModalVisible: (state, action) => {
      state.requireProductTestModalVisible = action.payload;
    },
  },
});

export const {
  fetchPerpBondList,
  fetchPerpBondListSuccess,
  fetchPerpBondListFailure,
  selectPerpBond,
  selectPerpBondSuccess,
  selectPerpBondFailure,
  clearError,
  saveVdoTime,
  acceptedVideo,
  acceptedKnowledgeAssessment,
  acceptedSecuritiesKnowledge,
  acceptedRiskAwareSignature,
  acceptedPreCaution,
  setRequireProductTestModalVisible,
} = slice.actions;

export default slice;
